import { buzzClient } from './client'
import type { BuzzEvent, Subscription, BuzzApiKey, BuzzApiKeyCreated, BuzzAuditLog } from '../types'

// ── Events ────────────────────────────────────────────────────────────────────
export const getEvents = (params?: { producer?: string; title?: string; isExpired?: boolean }) =>
  buzzClient.get<BuzzEvent[]>('/events', { params })

export const getEvent = (id: string) =>
  buzzClient.get<BuzzEvent>(`/events/${id}`)

export const createEvent = (data: { title: string; producer: string; description?: string; metadata?: Record<string, unknown>; lifeDurationMs: number }) =>
  buzzClient.post<BuzzEvent>('/events', data)

export const deleteEvent = (id: string) =>
  buzzClient.delete(`/events/${id}`)

// ── API Keys ──────────────────────────────────────────────────────────────────
export const getApiKeys = () =>
  buzzClient.get<BuzzApiKey[]>('/keys')

export const createApiKey = (data: { name: string; lifetimeYears: 1 | 2 | 3 }) =>
  buzzClient.post<BuzzApiKeyCreated>('/keys', data)

export const revokeApiKey = (id: string) =>
  buzzClient.delete(`/keys/${id}`)

// ── Config ────────────────────────────────────────────────────────────────────
export const getBuzzConfig = () =>
  buzzClient.get<import('../types').ServiceConfigParam[]>('/config')

export const setBuzzConfig = (key: string, value: string) =>
  buzzClient.post('/config', { [key]: value })

// ── Subscriptions ─────────────────────────────────────────────────────────────
export const getSubscriptions = (eventTitle?: string) =>
  buzzClient.get<Subscription[]>('/subscriptions', { params: eventTitle ? { eventTitle } : undefined })

export const createSubscription = (data: { subscriberId: string; eventTitle: string; callbackUrl: string }) =>
  buzzClient.post<Subscription>('/subscriptions', data)

export const deleteSubscription = (id: string) =>
  buzzClient.delete(`/subscriptions/${id}`)

// ── Audit Logs ────────────────────────────────────────────────────────────────
export const getBuzzAuditLogs = (params?: { action?: string; limit?: number }) =>
  buzzClient.get<BuzzAuditLog[]>('/audit-logs', { params })
